// src/layouts/LandingPageCountdown/LandingPageCountdown.js

import React from "react"
import styled from "styled-components"

import DataDotsRed from "../../svgs/landing-page/data-dots-red.svg"
import DataDotsWhite from "../../svgs/landing-page/data-dots-white.svg"

const ServiceList = ({ serviceListTitle, taskList }) => {
  return (
    <BlockContent>
      <div>
        <DataDotsRed className="data-dots-red" />
        <h2
          className="top-content"
          dangerouslySetInnerHTML={{ __html: serviceListTitle }}
        />
      </div>

      <ul class="task-list">
        {taskList.map(task => {
          return (
            <li>
              <div class="icon-circle">
                <DataDotsWhite className="data-dots-white" />
              </div>
              <span>{task.task}</span>
            </li>
          )
        })}
      </ul>
    </BlockContent>
  )
}

const BlockContent = styled.section`
  max-width: 810px;
  width: 100%;
  margin: 50px auto;
  padding: 0 20px;
  .data-dots-red {
    display: block;
    max-width: 100px;
    margin: 0 auto;
    margin-top: 70px;
    margin-bottom: 30px;
  }
  h1 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 60px;
    color: #2b2520;
    margin-top: 20px;
  }
  h2 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 50px;
    text-align: center;
  }
  h3 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    line-height: 70px;
    color: #2b2520;
    margin-top: 0;
  }
  h4 {
    font-family: "Nobel", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-size: 40px;
    line-height: 48px;
    color: #2b2520;
    margin-top: 0;
  }
  p.large {
    font-size: 32px;
    margin-bottom: 35px;
  }
  ul {
    list-style: none;
    li {
      background-color: #ebebeb;
      padding: 20px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 20px;
      span {
        font-family: "Nobel", sans-serif;
        font-weight: 700;
        font-size: 22px;
        line-height: 26px;
        color: #2b2520;
        width: calc(100% - 80px);
      }
      .icon-circle {
        background-color: #c44c4a;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;
        width: 60px;
        margin-right: 20px;
        .data-dots-white {
          max-width: 39px;
        }
      }
    }
  }
  .button-cta {
    text-align: center;
    button {
      background-color: #c44c4a;
      color: #fff;
      font-family: "Work Sans";
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1.6px;
      text-transform: uppercase;
      border: none;
      padding: 12px 35px;
      margin-top: 40px;
      &:hover {
        cursor: pointer;
      }
    }
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 20px 50px;
    flex-wrap: wrap;
    h2 {
      font-size: 44px;
      line-height: 1.3;
      margin-bottom: 10px;
      padding-left: 0;
    }
    h3 {
      font-size: 36px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    h4 {
      font-size: 28px;
      line-height: 1.3;
      margin-bottom: 10px;
    }
    p,
    ul {
      padding-left: 0;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    h2 {
      font-size: 36px;
    }
    h3 {
      font-size: 28px;
    }
    h4 {
      font-size: 20px;
    }
    ul {
      margin-left: 0;
    }
    p,
    ul {
      font-size: 16px;
      line-height: 1.6;
      li {
        span {
          font-size: 16px;
          line-height: 1.3;
        }
      }
    }
  }
`

export default ServiceList
